import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes } from '@news-mono/web-common'
import { layout } from '../../App.routing'

const westLiveSocialImage = require('./assets/TWL_podcast-twitter-facebook-ben-oshea-1200x630.jpg')

function getSocialImageMeta(src: string, height: string, width: string) {
    return [
        {
            property: 'og:image',
            content: src,
        },
        { name: 'twitter:image', content: src },
        {
            property: 'og:image:height',
            content: height,
        },
        {
            property: 'og:image:width',
            content: width,
        },
    ]
}

export const westlive: StaticRoutes<TheWestSection> = {
    '/the-west-live': ({ getAdTargeting, store, config }) => {
        if (
            !isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'the-west-live',
            )
        ) {
            return null
        }

        const canonicalUrl = config.publicUrl + '/the-west-live'

        return {
            kind: 'page',
            heading: 'The West Live',
            pageType: 'static',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: 'Perth news, The West Live podcast',
                description:
                    'Perth news that is live, local and a little loose. These are the stories peppered with a distinctive West Australian flavour, made especially for WA.',
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta(westLiveSocialImage, '630', '1200'),
            },
            socialMeta: {
                title: `The West Live podcast with Ben O'Shea`,
                description:
                    'It’s live, it’s local, it’s Perth news as you’ve never heard it before.',
            },
            adTargeting: getAdTargeting(
                'the-west-live',
                'default',
                'the-west-live',
            ),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'zeus',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                        hasBackgroundFill: true,
                        stretchSelf: true,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    verticalSpacing: 'md',
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'the-west-live-player-page',
                                            props: {
                                                adUnit: {
                                                    hiddenUntilLoaded: false,
                                                    noticePosition:
                                                        'below-center',
                                                    padding: [
                                                        metrics.thewest.margins
                                                            .md,
                                                        0,
                                                        0,
                                                        0,
                                                    ],
                                                    slot: {
                                                        id: 'leaderboard-one',
                                                        size:
                                                            'leaderboardResponsive',
                                                    },
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'iframe',
                                props: {
                                    link:
                                        'https://omny.fm/shows/the-west-live/playlists/podcast/embed?style=cover&image=1&share=1&download=0&description=1&subscribe=1&playlistimages=1&playlistshare=1&foreground=2b2c2d&background=f4f5f5&highlight=043de2',
                                    height: 800,
                                    marginBottom: 'lg',
                                },
                            }),
                            layout.component({
                                type: 'link-banner',
                                props: {
                                    url: `/newslettersubscribe`,
                                    message:
                                        'Get the latest news from thewest.com.au in your inbox.',
                                    cta: 'Sign up for our emails',
                                    verticalGutters: ['md', 'lg'],
                                },
                            }),
                            layout.component({
                                type: 'related-content',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'home',
                                        offset: 0,
                                        pageSize: 3,
                                    },
                                },
                            }),
                        ],
                        sidebar: [
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'sidebar-top',
                                        size: 'desktopMrecHalfPage',
                                        pageType: 'static',
                                    },
                                },
                            }),
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    stickyOffset: 350,
                                    fillContainer: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'ad-unit',
                                            props: {
                                                noticePosition: 'below-center',
                                                padding: [
                                                    0,
                                                    0,
                                                    metrics.thewest.margins.md,
                                                    0,
                                                ],
                                                slot: {
                                                    id: 'sidebar-middle',
                                                    size: 'desktopMrec',
                                                    pageType: 'static',
                                                },
                                            },
                                        }),

                                        layout.component({
                                            type: 'juliet',
                                            props: {
                                                cardType: {
                                                    type: 'landscape',
                                                    format:
                                                        'landscape-smallImage',
                                                },
                                                removeHorizontalGutters: true,
                                                kickerMode: 'hidden',
                                                contentIsTangential: true,
                                                sectionHeader: {
                                                    heading: 'Top Stories',
                                                    section: 'generic',
                                                },
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'home',
                                                    offset: 0,
                                                    pageSize: 3,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
